import type {UserSessionState} from "@stores/UserSessionState";

import {PaymentGateway} from "./types";
import {requestGateway} from "../actions/payment/requestGateway";
import {SeatManager} from "../services/SeatManager";
import {ClientInApp} from "../shared/types/SubscriptionTypes";


let paymentGateWayPromise: Promise<PaymentGateway> | null = null;


export const initializePaymentGateway = async (
    client: ClientInApp, 
    currentLocale: string,
    userState: UserSessionState
) => {
    let gateway: 'paddle' | 'invoice' | null = null;
    try {
        gateway = await requestGateway(userState.wsServerConnection);
    } catch (e) {
        console.error(e);
    }

    const envGateway = import.meta.env.VITE_APP_PAYMENT_GATEWAY;
    const finalGateway = gateway || (envGateway !== 'auto' ? envGateway : 'paddle');

    switch (finalGateway) {
        case 'paddle': {
            const {PaddlePaymentGateway} = await import('./providers/paddle/PaddlePaymentGateway');
            const seatUsage = await SeatManager.getSeatUsage(userState, true);
            const paymentGatewayInstance = new PaddlePaymentGateway(userState, client, seatUsage, currentLocale);
            await paymentGatewayInstance.init();
            return paymentGatewayInstance;
        }
        case 'invoice':
        default: {
            const {InvoicePaymentGateway} = await import('./providers/invoice/InvoicePaymentGateway');
            const seatUsage = await SeatManager.getSeatUsage(userState, true);
            // Note: InvoicePaymentGateway may need similar updates if it uses these values
            const paymentGatewayInstance = new InvoicePaymentGateway(userState, client, seatUsage);
            if (paymentGatewayInstance.init) {
                await paymentGatewayInstance.init();
            }
            return paymentGatewayInstance;
        }
    }
}

export const getPaymentGateway = async (
    client: ClientInApp, 
    currentLocale: string,
    userState: UserSessionState
) => {
    if (!paymentGateWayPromise) {
        paymentGateWayPromise = initializePaymentGateway(client, currentLocale, userState);
    }
    return await paymentGateWayPromise;
}

export const destroyPaymentGateway = async () => {
    if (paymentGateWayPromise) {
        const gateway = await paymentGateWayPromise;
        if (gateway?.destroy) {
            gateway.destroy();
        }
    }
    paymentGateWayPromise = null;
    return;
}
